<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1B8zpG4/tc-custom/9781250084613.jpg?1730583786823" alt="This image is the cover for the book Under the Surface, The Alpha Ops Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Under the Surface, The Alpha Ops Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Welcome to Eye Candy, the East Side’s hottest nightclub where the bartenders are hot, the cocktails are fancy, and danger lurks just under the surface…</b><br/><br/><br/> Eve Webber, the gorgeous and savvy owner of Eye Candy, knows better than anyone that growing up on the wrong side of the tracks comes with certain complications. Determined to run a clean business and fix up the East Side, Eve’s plans get temporarily stalled when a potential new hire walks into her bar. The sexual chemistry crackling between them is a potent distraction…even if she refuses to mix business with the promise of pleasure.<br/><br/><br/> Detective Matt Dorchester lives by strict rules that have kept him alive in impossible situations. When his latest undercover assignment has him playing a bartender, his desire for the passionate owner has him breaking every single one. Eve is in danger and her life depends on his secrecy. But once their attraction reaches a climactic conclusion, Matt must make a desperate choice: Tell her the truth about who he really is—or risk a once-in-a-lifetime love to save her life?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anne Calhoun
      </h2>
      
      <p class="authorDescription body article">After doing time at Fortune 500 companies on both coasts, Anne Calhoun landed in a flyover state, where she traded business casual for yoga pants and decided to write down all the lively story ideas that got her through years of monotonous corporate meetings. Her first book, LIBERATING LACEY won the EPIC Award for Best Contemporary Erotic Romance. Her story WHAT SHE NEEDS was chosen for Smart Bitch Sarah's Sizzling Book Club. Anne holds a BA in History and English, and an MA in American Studies from Columbia University. When she's not writing her hobbies include reading, knitting, and yoga. She lives in the Midwest with her family and singlehandedly supports her local Starbucks.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4363c5d9